import { render, staticRenderFns } from "./PDFView.vue?vue&type=template&id=dd1f56c0&scoped=true&"
import script from "./PDFView.vue?vue&type=script&lang=ts&"
export * from "./PDFView.vue?vue&type=script&lang=ts&"
import style0 from "./PDFView.vue?vue&type=style&index=0&id=dd1f56c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1f56c0",
  null
  
)

export default component.exports